import PropTypes from 'prop-types';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import ReactDOM from 'react-dom';
import * as rmd from 'material-ui';
import _ from 'lodash';
import auth from '../auth';
import specs from 'specs';
import { red500 } from 'material-ui/styles/colors';
import ErrorIcon from 'material-ui/svg-icons/alert/error';
import config from 'cfg';
import Promise from 'bluebird';
import loadScript from '../../../common/loadScript';
import pickers from './pickers';
import cx from 'classnames';
import DoneIcon from 'material-ui/svg-icons/action/done';
import ActionHome from 'material-ui/svg-icons/hardware/phone-iphone';

import IconXS from 'material-ui/svg-icons/hardware/phone-iphone';
import IconSM from 'material-ui/svg-icons/hardware/tablet-mac';
import IconMD from 'material-ui/svg-icons/hardware/laptop-mac';
import IconLG from 'material-ui/svg-icons/hardware/desktop-mac';
import IconAuto from 'material-ui/svg-icons/action/settings-overscan';

import IconOpenInNew from 'material-ui/svg-icons/action/open-in-new';
import IconDownload from 'material-ui/svg-icons/file/attachment';
import IconCode from 'material-ui/svg-icons/action/code';
import IconESI from 'material-ui/svg-icons/places/all-inclusive';
import IconIframe from 'material-ui/svg-icons/av/web';

var previewSizeIcons = {
    xs: IconXS,
    sm: IconSM,
    md: IconMD,
    lg: IconLG,
    auto: IconAuto,
};

var C_MEDIA_LOCALSTORAGE = 'C_MEDIA_LOCALSTORAGE';
var C_GLOBAL_SETUP = 'C_GLOBAL_SETUP';

import prodConfig from '../../../../config/prod.json';
var STAGE_WIDGETS_URL = prodConfig.widgets.url;

var iconStyle = {
    width: 30,
    height: 30,
    marginRight: 15,
    marginBottom: -10,
};

class WidgetCustomizer extends React.Component {
    constructor(props, context) {
        super(props, context);

        var { wiid } = props.location.query;

        this.state = {
            isLoading: true,
            widget: {},
            clientSpec: {},
            propValues: {},
            // propValues: {...props.location.query},
            modalIsOpen: false,
            widgetWidth: 500,
            previewHeight: 500,
            wiid: wiid,
            previewSize: localStorage.getItem(C_MEDIA_LOCALSTORAGE) || 'auto',
            globalSetup: localStorage.getItem(C_GLOBAL_SETUP) === 'true' || false,
            previewProps: {},
            previewPropsJS: {},
            globalSetupDialogue: false,
            showWPInstructions: false,
        };

        this.loadData();
    }

    componentDidMount = () => {
        window.addEventListener(
            'message',
            _.debounce(message => {
                // console.log("WC >> WIDGET POST MESSAGE ABOUT HEIGHT CHANGE");
                try {
                    var data = JSON.parse(message.data);
                    if (this.state.previewWidth !== data.width || this.state.previewHeight !== data.height) {
                        this.setState({
                            previewWidth: data.width,
                            previewHeight: data.height,
                        });
                    }
                } catch (e) {
                    console.log(e);
                }
            }, 1000),
            false,
        );
    };

    componentWillUpdate = (nextProps, nextState) => {
        nextState.previewProps = this.createPreviewProps(true, nextState);
        nextState.previewPropsJS = this.createPreviewProps(false, nextState);
    };

    static contextTypes = {
        user: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
    };

    loadData = () => {
        // console.log("WC >> LOAD DATA");
        var { user } = this.context;
        var { defaultTheme } = user;
        var { widgetId } = this.props.params;

        if (!user || !user.client) return null;
        return Promise.props({
            clientSpec: fetch(`${config.dash.api.host}/api/widgets/spec?access_token=${auth.getAccessToken()}`),
            widget: fetch(`${config.widgets.url}/widgets/standalone/${widgetId}/spec`),
            themes: fetch(`${config.dash.api.host}/api/themes?access_token=${auth.getAccessToken()}`),
        })
            .then(result => {
                return Promise.props({
                    clientSpec: result.clientSpec.status === 200 && result.clientSpec.json(),
                    widget: result.widget.status === 200 && result.widget.json(),
                    themes: result.themes.status === 200 && result.themes.json(),
                });
            })
            .then(results => {
                var clientPreferences = _.chain(user.defaultProps)
                    // .filter(prop => _.find(results.widget.propTypes, {key: prop.key}))
                    .map(prop => [prop.key, prop.value])
                    .fromPairs()
                    .value();

                var widgetDefaults = _.chain(results.widget.propTypes)
                    .map(i => {
                        return [i.key, i.defaultValue];
                    })
                    .fromPairs()
                    .value();

                // detect default theme
                var theme = results.themes.find(t => t.id === defaultTheme) || _.first(results.themes);

                var mergedProps = _.merge(
                    {
                        theme: theme && theme.id,
                    },
                    widgetDefaults,
                    clientPreferences,
                    this.props.location.query,
                );

                // console.log("WC >> DATA LOADED");
                this.setState({
                    widget: results.widget,
                    clientSpec: results.clientSpec,
                    propValues: mergedProps,
                    isLoading: false,
                });
            })
            .catch(err => {
                console.error(err);
                this.setState({ err: err, isLoading: false });
            });
    };

    changePropValue(prop, val) {
        let changedProp;
        if (typeof prop === 'object') {
            changedProp = prop;
        } else {
            changedProp = {};
            changedProp[prop] = val;
        }

        var propValues = Object.assign({}, this.state.propValues, changedProp);
        this.setState({ propValues: propValues }, () => {
            this.updateWIID(this.state.wiid);
        });
    }

    createPreviewProps(dataAttributes = true, state) {
        var previewProps = {};
        var nextState = state || this.state;
        var widgetProps = nextState.widget.propTypes || [];

        widgetProps.forEach(prop => {
            var toMap = { ...prop.propsMap, ..._.fromPairs([[prop.key, prop.key]]) };
            // var toMap = _.fromPairs([[prop.key, prop.key]]);

            Object.keys(toMap).forEach(from => {
                var to = toMap[from];
                var value = nextState.propValues[from];

                try {
                    value = JSON.parse(value);
                } catch (e) {
                    value = nextState.propValues[from];
                }

                if (Array.isArray(value)) {
                    value = JSON.stringify(value);
                }

                if (typeof value === 'object') {
                    value = JSON.stringify(value);
                }

                var key = dataAttributes ? 'data-' + _.kebabCase(to) : to;

                if (value !== '' && value !== undefined && value !== null) previewProps[key] = value;
            });
        });

        return previewProps;
    }
    generateAssets() {
        var { user } = this.context;
        return `<script type="text/javascript" src="${config.WDPLinkr.injector()}" crossorigin></script>
<link rel="stylesheet" type="text/css" href="${config.WDPLinkr.client.cssPath(
            user.client,
            user.username,
            this.state.propValues.theme,
        )}"/>`;
    }

    generateIframe = () => {
        var { widgetId } = this.props.params;
        var { widget, globalSetup, previewHeight, previewProps, previewPropsJS } = this.state;
        var { user } = this.context;
        return config.WDPLinkr.widget.iframe(
            user.client,
            user.username,
            this.state.propValues.theme,
            widgetId,
            previewPropsJS,
        );
    };
    generateWPShortcutCode() {
        return `function handle_rlz_widget_shortcode ( $atts, $content = null ) {
    $params = "";
    foreach ($atts as $key => $value) {
        if (substr($value, 0, 1) == '$') $value = $_GET[substr($value, 1)];
        $params .= $key . '="' . $value . '" ';
    }
    return "<rlz-widget " . $params . "></rlz-widget>";
}

add_shortcode('rlz-widget', 'handle_rlz_widget_shortcode');
`;
    }
    generateCode(method, all, previewProps, optionalParams = {}, isWP = false) {
        var { user } = this.context;
        var { widgetId } = this.props.params;
        var commonParams = {
            'data-load': method,
            'data-client': user.client,
            'data-user': user.username,
            'data-theme': this.state.propValues.theme,
            'data-token': user.accessToken,
            'data-ga': user.defaultProps.GA,
            'data-lang': this.state.propValues.lang,
        };
        var pp = _.clone(previewProps);
        Reflect.deleteProperty(pp, 'data-theme');
        Reflect.deleteProperty(pp, 'data-debug');

        var params = _.extend({}, pp, all && commonParams, optionalParams);

        if (isWP) {
            var paramsStr = _.chain(params)
                .toPairs()
                .reduce((memo, p) => `${memo}  ${p[0]}="${JSON.stringify(p[1])}"`, '')
                .value();
            return `[rlz-widget data-name=${widgetId} data-wiid=${this.state.wiid} ${paramsStr} /]`;
        }

        return ReactDOMServer.renderToStaticMarkup(
            <rlz-widget data-name={widgetId} data-wiid={this.state.wiid} {...params} />,
        );
    }

    generateSetup(global = false, loadMethod = 'js', crossorigin = true) {
        var { user } = this.context;
        var output = '';
        if (crossorigin) {
            output = `<script type="text/javascript" src="${config.WDPLinkr.injector()}" crossorigin></script>`;
        } else {
            output = `<script type="text/javascript" src="${config.WDPLinkr.injector()}"></script>`;
        }

        var defaults = `
<script type="text/javascript">
    WDPDefaults.set("client", "${user.client}");
    WDPDefaults.set("user", "${user.username}");
    WDPDefaults.set("theme", "${this.state.propValues.theme}");
    WDPDefaults.set("token", "${user.accessToken}");
    WDPDefaults.set("ga",    "${user.defaultProps.GA || ''}");
    WDPDefaults.set("load",  "${loadMethod}");
    WDPDefaults.set("lang",  "${this.state.propValues.lang || 'en'}");
</script>`;

        return output + (global ? defaults : '');
    }

    renderJSStep1(load = 'js') {
        var { globalSetup } = this.state;
        return (
            <div>
                <p>
                    1. Enter init script once a page where widget. In &lt;head/&gt; or bottom of all pages with widgets
                </p>
                <textarea
                    readOnly
                    style={{ width: '100%' }}
                    rows={globalSetup ? 10 : 2}
                    value={this.generateSetup(globalSetup, load)}
                />
                <rmd.Checkbox
                    label="Define WDPDefaults (theme, lang, accesstoken) globally"
                    style={{ marginTop: '10px', fontSize: '12px' }}
                    checked={this.state.globalSetup}
                    onCheck={(e, val) => {
                        this.setState({ globalSetup: val });
                        localStorage.setItem(C_GLOBAL_SETUP, true);
                    }}
                />
            </div>
        );
    }

    renderEmbedCode() {
        var { user } = this.context;
        var { widgetId } = this.props.params;
        var { widget, globalSetup, previewHeight, previewProps, previewPropsJS } = this.state;

        return (
            <rmd.Card className="card embed-code">
                <rmd.Tabs>
                    <rmd.Tab label="JS Embed" icon={<IconCode />}>
                        <rmd.CardText>
                            <h3>Widget integration using embed code [JS integration]</h3>
                            {this.renderJSStep1()}
                            <p>2. Put widget &lt;embed/&gt; code on a page</p>
                            <textarea
                                readOnly
                                style={{ width: '100%' }}
                                rows={3}
                                value={this.generateCode('js', !globalSetup, previewProps)}
                            />
                            <p>
                                Wordpress shortcode (
                                <a
                                    style={{
                                        color: 'rgb(0, 188, 212)',
                                        fontSize: '12px',
                                        textDecoration: 'underline',
                                    }}
                                    href="#"
                                    onClick={() => this.setState({ showWPInstructions: true })}
                                >
                                    Get a WP shortcut code
                                </a>
                                )
                            </p>
                            <textarea
                                readOnly
                                style={{ width: '100%' }}
                                rows={3}
                                value={this.generateCode('js', !globalSetup, previewProps, {}, true)}
                            />
                        </rmd.CardText>
                    </rmd.Tab>
                    <rmd.Tab label="Iframe" icon={<IconIframe />}>
                        <rmd.CardText>
                            <h3>Link to widget that can be used in iframe</h3>
                            <textarea readOnly style={{ width: '100%' }} rows={2} value={this.generateIframe()} />

                            <h3>Widget integration using embed code [Iframe integration]</h3>

                            {this.renderJSStep1('iframe')}
                            <p>2. Put widget &lt;embed/&gt; code on a page</p>
                            <textarea
                                readOnly
                                style={{ width: '100%' }}
                                rows={3}
                                value={this.generateCode('iframe', !globalSetup, previewProps)}
                            />
                            <p>
                                Wordpress shortcode (
                                <a
                                    style={{
                                        color: 'rgb(0, 188, 212)',
                                        fontSize: '12px',
                                        textDecoration: 'underline',
                                    }}
                                    href="#"
                                    onClick={() => this.setState({ showWPInstructions: true })}
                                >
                                    Get a WP shortcut code
                                </a>
                                )
                            </p>
                            <textarea
                                readOnly
                                style={{ width: '100%' }}
                                rows={3}
                                value={this.generateCode('iframe', !globalSetup, previewProps, true)}
                            />
                        </rmd.CardText>
                    </rmd.Tab>
                    <rmd.Tab label="ESI" icon={<IconESI />}>
                        <rmd.CardText>
                            <h3>Link to widget that can be used for ESI</h3>
                            <textarea
                                readOnly
                                style={{ width: '100%' }}
                                rows={2}
                                value={config.WDPLinkr.widget.esi(
                                    user.client,
                                    user.username,
                                    this.state.propValues.theme,
                                    widgetId,
                                    previewPropsJS,
                                )}
                            />
                            <p>You will have to include on page following libraries</p>
                            <textarea readOnly style={{ width: '100%' }} rows={5} value={this.generateAssets()} />
                        </rmd.CardText>
                    </rmd.Tab>
                </rmd.Tabs>
                <rmd.CardActions>
                    {/*<rmd.RaisedButton label="Save template" primary={true} onClick={this.saveWidgetTemplate}/> */}
                    {this.state.isSaving ? (
                        <rmd.CircularProgress size={0.4} style={{ position: 'absolute', right: 0, top: 0 }} />
                    ) : (
                        ''
                    )}
                    {this.state.saveSuccess ? (
                        <DoneIcon
                            style={{
                                position: 'absolute',
                                right: 5,
                                bottom: 15,
                            }}
                        />
                    ) : (
                        ''
                    )}
                </rmd.CardActions>
            </rmd.Card>
        );
    }

    renderWidgetPreview() {
        var { user } = this.context;
        var { widgetId } = this.props.params;
        var { wiid } = this.props.location.query;
        var { isLoading, widget, clientSpec, previewProps, previewWidth, previewHeight, previewPropsJS } = this.state;

        var iframeURL = config.WDPLinkr.widget.iframe(
            user.client,
            user.username,
            this.state.propValues.theme,
            widgetId,
            previewPropsJS,
        );

        var smURL = config.WDPLinkr.widget.sm(
            user.client,
            user.username,
            this.state.propValues.theme,
            widgetId,
            previewPropsJS,
        );

        return (
            <rmd.Card className="card widget-preview">
                <rmd.Toolbar>
                    <rmd.ToolbarGroup firstChild />
                    {widget && !widget.social && (
                        <rmd.ToolbarGroup>
                            <rmd.ToolbarTitle text="Preview on" />
                            {['xs', 'sm', 'md', 'lg', 'auto'].map(dm => {
                                var IconXX = previewSizeIcons[dm];
                                return (
                                    <rmd.IconButton
                                        key={dm}
                                        label={dm}
                                        disabled={this.state.previewSize === dm}
                                        onClick={e => {
                                            localStorage.setItem(C_MEDIA_LOCALSTORAGE, dm);
                                            this.setState({ previewSize: dm }, () =>
                                                window.dispatchEvent(new Event('resize')),
                                            );
                                        }}
                                    >
                                        {IconXX && <IconXX />}
                                    </rmd.IconButton>
                                );
                            })}
                        </rmd.ToolbarGroup>
                    )}
                </rmd.Toolbar>
                {/*key={JSON.stringify(previewProps)}*/}
                <rmd.CardText className="wdp-preview-container">
                    <div
                        id="wdp-preview"
                        className={`wdp-preview wdp-preview-${widget.social ? '800px' : this.state.previewSize}`}
                    >
                        {!isLoading && (
                            <rlz-widget
                                ref="preview"
                                data-name={widgetId}
                                data-load="js"
                                data-client={user.client}
                                data-user={user.username}
                                data-token={user.accessToken}
                                data-wiid={this.state.wiid}
                                data-customizer={'true'}
                                {...previewProps}
                            />
                        )}
                    </div>
                    {previewWidth && previewHeight && (
                        <div className="wdp-preview-sizes">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Width</td>
                                        <td>{previewWidth}px</td>
                                    </tr>
                                    <tr>
                                        <td>Height</td>
                                        <td>{previewHeight}px</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                </rmd.CardText>
                <rmd.CardText>
                    {
                        <rmd.Toggle
                            label={`Use preview widget height (${previewHeight || 100}px) as default`}
                            disabled={!previewHeight}
                            labelPosition="right"
                            toggled={this.state.propValues.defaultHeight > 0}
                            onToggle={(e, usePreviewHeight) => {
                                this.changePropValue(
                                    'defaultHeight',
                                    (usePreviewHeight && this.state.previewHeight) || '',
                                );
                                this.setState({
                                    usePreviewHeight,
                                    previewHeight,
                                });
                            }}
                        />
                    }
                </rmd.CardText>
                <rmd.CardActions className="actions">
                    <rmd.FlatButton
                        href={this.state.widget.social ? smURL : iframeURL}
                        label="Open in new Window"
                        target="_blank"
                        icon={<IconOpenInNew />}
                    />
                    <rmd.FlatButton
                        label={`example-${widgetId}.html`}
                        onClick={this.handleExampleDownload}
                        icon={<IconDownload />}
                    />
                </rmd.CardActions>
            </rmd.Card>
        );
    }
    handleExampleDownload = () => {
        var link = document.createElement('a');
        var { previewProps } = this.state;
        var { widgetId } = this.props.params;
        link.download = `Example-${widgetId}.html`;
        link.href =
            'data:text/plain;base64,' +
            btoa(`
<!-- INIT SCRIPT CODE -->
${this.generateSetup(false, 'js', false)}
<!-- EMBED CODE -->
${this.generateCode('js', true, previewProps)}`);
        link.click();
    };
    renderPicker = (prop, i, array) => {
        var Picker = pickers[prop.type];
        if (!Picker) return <div>{prop.type}</div>;
        const { user } = this.context;
        var clientPreferences = _.chain(user.defaultProps)
            .map(prop => {
                var val = prop.value;
                try {
                    val = JSON.parse(prop.value);
                } catch (e) {
                    //console.log(e);
                }
                return [prop.key, val];
            })
            .fromPairs()
            .value();

        return [
            <rmd.CardText key={prop.key + 'p'}>
                <Picker
                    {...prop}
                    {...prop.props}
                    {...clientPreferences}
                    {...this.state.previewPropsJS}
                    key={prop.key}
                    propKey={prop.key}
                    value={this.state.previewPropsJS[prop.key]}
                    onChange={this.changePropValue.bind(this)}
                    error={this.state.error}
                />
            </rmd.CardText>,
            i !== array.length - 1 && <rmd.Divider key={prop.key + 'd'} />,
        ];
    };

    renderGlobalSetupCodeSnipped = () => {
        const actions = [
            false && <rmd.FlatButton label="Copy" secondary onTouchTap={() => {}} />,
            <rmd.FlatButton label="Close" primary onTouchTap={() => this.setState({ globalSetupDialogue: false })} />,
        ];
        var styles = {
            maxWidth: '90%',
            height: '90%',
        };
        return (
            <rmd.Dialog
                open={this.state.globalSetupDialogue}
                modal={false}
                actions={actions}
                onRequestClose={() => this.setState({ globalSetupDialogue: false })}
                contentStyle={styles}
                autoScrollBodyContent
            >
                <div className="preview">
                    <h3>Global setup</h3>
                    <textarea readOnly style={{ width: '100%' }} rows={15} value={this.generateSetup()} />
                </div>
            </rmd.Dialog>
        );
    };

    renderWPInstructions = () => {
        const actions = [
            <rmd.FlatButton label="Close" primary onTouchTap={() => this.setState({ showWPInstructions: false })} />,
        ];
        var styles = {
            maxWidth: '90%',
            height: '90%',
        };
        var codeStyle = {
            color: '#000',
            fontSize: '14px',
        };
        return (
            <rmd.Dialog
                open={this.state.showWPInstructions}
                modal={false}
                actions={actions}
                onRequestClose={() => this.setState({ showWPInstructions: false })}
                contentStyle={styles}
                autoScrollBodyContent
            >
                <div className="preview">
                    <h3>Shortcut for default WYSIWYG editor</h3>
                    <p>
                        It is possible to install shortcut using availble free plugins with no actual php coding. Using
                        shortcode in Wordpress editor is best option because of next issues:
                    </p>
                    <ul>
                        <li>By default WP will try to wrap &lt;rlz-widget/&gt; with &lt;p/&gt;</li>
                        <li>
                            This macro will allow to read get parameters from querystring, which is very useful when
                            using WDPDeeplinker
                        </li>
                    </ul>
                    <p>
                        To access get parameter from querystring{' '}
                        <code style={codeStyle}>/matchcenter?eventId=123456</code> attribute in macros should look like{' '}
                        <code style={codeStyle}>eventId="$eventId"</code>
                    </p>
                    <p>
                        In the end embed code of widget should look like this:
                        <br />
                        <br />
                        <code style={codeStyle}>
                            [rlz-widget data-name="TournamentTable" data-tournament-id="$tournamentId" /]
                        </code>
                    </p>
                    <p>Complete code of shortcode listed below:</p>
                    <textarea readOnly style={{ width: '100%' }} rows={15} value={this.generateWPShortcutCode()} />
                </div>
            </rmd.Dialog>
        );
    };

    updateWIID = (wiid, template) => {
        const { widgetId } = this.props.params;
        const params = {
            userId: this.context.user._id,
            props: this.state.propValues,
            template: template,
        };
        let url = `${config.dash.api.host}/api/widgets/${widgetId}`;
        if (wiid) {
            url += '/' + wiid;
        }

        return fetch(url, {
            method: 'post',
            body: JSON.stringify(params),
            headers: { 'Content-Type': 'application/json' },
        })
            .then(response => response.json())
            .then(widgetInstance => {
                if (!wiid) {
                    // console.log("WC >>  WIID SAVED");
                    this.setState({ wiid: widgetInstance._id });
                }
                // console.log("WC >> URL WAS UPDATED...");
                this.context.router.replace({
                    ...this.props.location,
                    query: Object.assign({}, this.state.previewPropsJS, {
                        wiid: widgetInstance._id,
                    }),
                });
            })
            .catch(err => {
                console.error(err);
                this.setState({ error: err, isSaving: false });
            });
    };

    // saveWidgetTemplate = () => {
    //     this.setState({isSaving: true});
    //     return this.updateWIID(this.state.wiid, true).then(() => this.setState({saveSuccess: true}));
    // }
    renderSocialPost = () => {
        if (!this.state.widget.social) return;
        return (
            <rmd.Card className="card sm-share" style={{ display: 'block' }}>
                <rmd.CardHeader title="Share to SM" />
                <rmd.CardText>
                    <rmd.TextField
                        floatingLabelText="Image width, px"
                        value={this.state.widgetWidth}
                        style={{ marginRight: '30px' }}
                        onChange={this.handleParamChange.bind(this, 'widgetWidth')}
                    />
                </rmd.CardText>
                <rmd.CardActions>
                    <rmd.RaisedButton label="Image" primary onClick={this.openImagePreview.bind(this)} />
                </rmd.CardActions>
            </rmd.Card>
        );
    };
    renderModal() {
        var styles = {
            maxWidth: '90%',
            height: '90%',
            width: +this.state.widgetWidth + 48,
        };

        const buttonStyles = {
            margin: '0 6px',
        };
        const okIconUrl = 'http://s10.postimg.org/3yid0uket/success.png';
        const errorIconUrl = 'http://s10.postimg.org/86d59llud/fail.png';

        const actions = [
            <rmd.FlatButton label="Cancel" secondary onTouchTap={this.closeModal.bind(this)} />,
            <rmd.FlatButton label="Download" primary onTouchTap={this.downloadImage.bind(this)} />,
            /*<rmd.FlatButton
                primary={true}
                label="Post to Facebook"
            />,
            <rmd.FlatButton
                primary={true}
                label="Post to Twitter"
            />*/
        ];

        return (
            <rmd.Dialog
                open={this.state.modalIsOpen}
                modal={false}
                actions={actions}
                onRequestClose={this.closeModal.bind(this)}
                contentStyle={styles}
                autoScrollBodyContent
            >
                {/*<div className="info">
                    <div className="row">
                        <div className="col-md-10">
                            <h3 className="info-header">Customize header/url</h3>
                            <div className="custom-params-inputs">
                                <rmd.TextField
                                    floatingLabelText="Header"
                                    value={this.state.postHeader}
                                    style={{marginRight: '30px'}}
                                    onChange={this.handleParamChange.bind(this, 'postHeader')}
                                />
                                <rmd.TextField
                                    floatingLabelText="Url"
                                    value={this.state.postUrl}
                                    onChange={this.handleParamChange.bind(this, 'postUrl')}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div style={{float: 'right', width: '70px', height: '70px', position: 'relative'}}>
                                {this.state.status === 'inprogress' ? <rmd.CircularProgress /> : ''}
                                {this.state.status === 'success' ? <img style={{position: 'absolute', transform: 'translate(-50%,-50%)', left: '50%', top: '50%'}} src={okIconUrl} /> : ''}
                                {this.state.status === 'error' ? <img style={{position: 'absolute', transform: 'translate(-50%,-50%)', left: '50%', top: '50%'}} src={errorIconUrl} /> : ''}
                            </div>
                        </div>
                    </div>
                </div>*/}
                <div className="preview">
                    <h3>Preview</h3>
                    <div
                        className="preview-image-wrapper"
                        id="preview-image-wrapper"
                        style={{
                            maxWidth: this.state.widgetWidth + 'px',
                            height: this.state.contentHeight ? this.state.contentHeight + 'px' : false,
                        }}
                    >
                        <img
                            onLoad={() => (document.getElementById('preview-image-wrapper').style.height = 'auto')}
                            id="preview-image"
                            src={this.state.previewUrl}
                            className="preview-image"
                            alt="preview"
                        />
                    </div>
                </div>
            </rmd.Dialog>
        );
    }

    handleParamChange(param, event) {
        const obj = {};
        obj[param] = event.target.value;
        this.setState(obj);
    }

    downloadImage() {
        var link = document.createElement('a');
        link.download = this.props.params.widgetId;
        link.href = this.state.previewUrl;
        link.click();
    }

    openImagePreview() {
        // var widgetName = this.props.widgetName;
        // var iframe = document.getElementById('target');
        // var widgetHeight = iframe.height && parseInt(iframe.height);

        var convertUrl = config.apis.webshot + '/api/convert';
        var { user } = this.context;
        var { widgetId } = this.props.params;
        var { previewPropsJS } = this.state;

        var widgetIframeUrl = config.WDPLinkr.widget.iframe(
            user.client,
            user.username,
            previewPropsJS.theme,
            widgetId,
            previewPropsJS,
        );

        // TEMP:
        // webshot can't access localhost
        widgetIframeUrl = widgetIframeUrl.replace('http://127.0.0.1:3003', STAGE_WIDGETS_URL);
        // console.log(widgetIframeUrl)
        const imageQuality = 100;

        var params = {
            // "filename": widgetName,
            quality: imageQuality,
            url: widgetIframeUrl,
            captureSelector: '.wdp',
            whiteBg: false,
            browser: config.webshotBrowser,
            // "offset" + offset +
            // "windowHeight" + widgetHeight +
            windowWidth: this.state.widgetWidth,
            renderDelay: 2000,
        };

        fetch(convertUrl, {
            method: 'post',
            body: JSON.stringify(params),
            headers: { 'Content-Type': 'application/json' },
        })
            .then(response => response.json())
            .then(json => this.openModal(json.url));
    }

    openModal(previewUrl) {
        this.setState({ modalIsOpen: true, previewUrl: previewUrl });
    }

    closeModal() {
        this.clearPreview();
        this.setState({
            modalIsOpen: false,
            status: null,
            postHeader: null,
            postUrl: null,
        });
    }

    clearPreview() {
        var filename = this.state.previewUrl.split('/').pop();
        var deleteUrl = config.apis.webshot + '/api/clear/' + filename;

        fetch(deleteUrl, { method: 'delete' });
    }

    render() {
        var { user } = this.context;
        var { widgetId } = this.props.params;
        var { isLoading, widget, clientSpec, previewProps, previewPropsJS } = this.state;
        var widgetProps = widget.propTypes || [];

        if (!isLoading && _.isEmpty(clientSpec)) {
            return (
                <div>
                    <ErrorIcon color={red500} style={iconStyle} />
                    Widget specification not found for client {user.client}
                </div>
            );
        }

        var ThemePicker = pickers['theme_picker'];

        var groupedWidgetProps = _.groupBy(widgetProps, w => {
            return w.scope || 'custom';
        });

        var titles = {
            custom: {
                title: 'Main widget parameters',
                subtitle: 'Setup widget to Your needs',
            },
            template: {
                title: 'Pick a template',
                subtitle: 'Setup widget to Your needs',
            },
            styling: {
                title: 'Styling',
                subtitle: 'Setup widget to Your needs',
            },
            common: {
                title: 'Common parameters',
                subtitle: 'Control header, more button, language etc',
            },
            images: {
                title: 'Preview image parameters',
                subtitle: 'Control editorial images',
            },
        };

        var commonParamsExpanded = previewPropsJS.suppressHeader === true || !_.isEmpty(previewPropsJS.moreButtonLabel);

        return (
            <div className="widget-customizer">
                <div className="widget-customizer__variables">
                    {!widgetProps.length && (
                        <rmd.Card className="card widget-params">
                            <rmd.CardText>No params defined for widget</rmd.CardText>
                        </rmd.Card>
                    )}
                    <rmd.Card style={{ marginTop: '0px' }}>
                        <rmd.CardHeader title={`${widget.id}`} subtitle={widget.name} />
                    </rmd.Card>
                    {_.toPairs(groupedWidgetProps).map(pair => {
                        const group = pair[0];
                        const widgets = pair[1];
                        return (
                            <rmd.Card key={group} className="card widget-params" initiallyExpanded>
                                <rmd.CardHeader
                                    style={{ background: '#f3f3f3' }}
                                    title={(titles[group] && titles[group].title) || ''}
                                    subtitle={(titles[group] && titles[group].subtitle) || ''}
                                    actAsExpander
                                    showExpandableButton
                                />
                                <rmd.CardText expandable style={{ padding: 0 }}>
                                    {widgets && _.filter(widgets, p => p.type !== 'hidden').map(this.renderPicker)}
                                </rmd.CardText>
                            </rmd.Card>
                        );
                    })}

                    <rmd.Card className="card widget-preview">
                        <rmd.CardHeader
                            style={{ background: '#f3f3f3' }}
                            title="Widget documentation"
                            subtitle="Available properties"
                            actAsExpander
                            showExpandableButton
                        />
                        <rmd.CardText expandable key="props">
                            <pre>{JSON.stringify(previewProps, null, 4)}</pre>
                        </rmd.CardText>
                    </rmd.Card>
                </div>
                <div className="widget-customizer__content">
                    {this.renderWidgetPreview()}
                    {this.renderEmbedCode()}
                    {false && this.renderSocialPost()}
                </div>

                {this.renderModal()}
                {this.renderGlobalSetupCodeSnipped()}
                {this.renderWPInstructions()}
            </div>
        );
    }
}

export default WidgetCustomizer;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/WidgetCustomizer.js
 **/